import A from "./A";

export default A;
